'use strict';
(function() {
  theme.MobileNav = function() {
    function d(a) {
      this.config = Object.assign({}, h, a);
      this.namespace = ".nav-header-" + a.id;
      if (this.container = document.getElementById(this.config.id)) {
        if (this.wrapper = this.container.querySelector(b.wrapper)) {
          this.nav = this.wrapper.querySelector(b.nav), this.openTriggers = document.querySelectorAll(b.openBtn), this.init();
        }
      }
    }
    var b = {wrapper:".mobile-nav__wrapper", nav:".mobile-nav", childList:".mobile-nav__dropdown", allLinks:"a.mobile-nav__link", subNavToggleBtn:".js-toggle-submenu", openBtn:".mobile-nav-trigger"}, h = {isOpen:!1, menuLevel:1, inHeader:!1};
    d.prototype = Object.assign({}, d.prototype, {init:function() {
      this.nav.querySelectorAll(b.subNavToggleBtn).forEach(a => {
        a.addEventListener("click", this.toggleSubNav.bind(this));
      });
      this.nav.querySelectorAll(b.allLinks).forEach(a => {
        a.addEventListener("click", this.close.bind(this));
      });
      this.inHeader && (document.addEventListener("unmatchSmall", function() {
        this.close(null, !0);
      }.bind(this)), document.addEventListener("CartDrawer:open", this.close.bind(this)), document.addEventListener("mobileNav:open", this.open.bind(this)), document.addEventListener("mobileNav:close", this.close.bind(this)));
    }, open:function(a) {
      1 != this.config.isOpen && (a && a.preventDefault(), theme.sizeDrawer(), this.openTriggers.forEach(c => {
        c.classList.add("is-active");
      }), theme.Helpers.prepareTransition(this.container, function() {
        this.container.classList.add("is-active");
      }.bind(this)), window.on("keyup" + this.namespace, function(c) {
        27 === c.keyCode && this.close();
      }.bind(this)), document.documentElement.classList.add("mobile-nav-open"), document.dispatchEvent(new CustomEvent("MobileNav:open")), this.config.isOpen = !0, setTimeout(function() {
        document.querySelector(".header-sticky-wrapper").on("click" + this.namespace, function(c) {
          this.close(c);
        }.bind(this));
      }.bind(this), 0));
    }, close:function(a, c) {
      if (!(null != a && a.target.closest(".drawer__scrollable") || 0 == this.config.isOpen)) {
        var g = !1;
        if (a && a.target.closest && a.target.closest(".site-header__drawer") && (a.currentTarget && a.currentTarget.classList && a.currentTarget.classList.contains("mobile-nav__link") && (g = !0), !g)) {
          return;
        }
        this.openTriggers.forEach(f => {
          f.classList.remove("is-active");
        });
        c ? this.container.classList.remove("is-active") : theme.Helpers.prepareTransition(this.container, function() {
          this.container.classList.remove("is-active");
        }.bind(this));
        document.documentElement.classList.remove("mobile-nav-open");
        document.dispatchEvent(new CustomEvent("MobileNav:close"));
        window.off("keyup" + this.namespace);
        window.off("click" + this.namespace);
        document.querySelector(".header-sticky-wrapper").off("click" + this.namespace);
        this.config.isOpen = !1;
      }
    }, toggleSubNav:function(a) {
      this.goToSubnav(a.currentTarget.dataset.target);
    }, goToSubnav:function(a) {
      (a = this.nav.querySelector(b.childList + '[data-parent="' + a + '"]')) ? (this.config.menuLevel = a.dataset.level, 2 == this.config.menuLevel && this.nav.querySelectorAll(b.childList + '[data-level="3"]').forEach(c => {
        c.classList.remove("is-active");
      }), a.classList.add("is-active"), this.setWrapperHeight(a.offsetHeight)) : (this.config.menuLevel = 1, this.wrapper.removeAttribute("style"), this.nav.querySelectorAll(b.childList).forEach(c => {
        c.classList.remove("is-active");
      }));
      this.wrapper.dataset.level = this.config.menuLevel;
    }, setWrapperHeight:function(a) {
      this.wrapper.style.height = a + "px";
    }});
    return d;
  }();
  theme.Drawers = function() {
    function d(b, h) {
      this.config = {id:b, close:".js-drawer-close", close2:".js-drawer-close2", open:".js-drawer-open-" + h, openClass:"js-drawer-open", closingClass:"js-drawer-closing", activeDrawer:"drawer--is-open", namespace:".drawer-" + h};
      this.nodes = {page:document.querySelector("#MainContent"), header:document.querySelector("#HeaderWrapper")};
      this.drawer = document.querySelector("#" + b);
      this.isOpen = !1;
      this.drawer && this.init();
    }
    d.prototype = Object.assign({}, d.prototype, {init:function() {
      this.mobileNav = new theme.MobileNav({id:"MobileNav", inHeader:!0});
      document.querySelectorAll(this.config.open).forEach(b => {
        b.setAttribute("data-expanded", "false");
        b.addEventListener("click", this.open.bind(this));
      });
      this.drawer.querySelector(this.config.close).addEventListener("click", this.close.bind(this));
      this.announcementWrapper = document.querySelector("#AnnouncementWrapper");
      document.addEventListener("modalOpen", function() {
        this.close();
      }.bind(this));
    }, open:function(b, h) {
      this.mobileNav.open();
      b && b.preventDefault();
      this.isOpen || (this.mobileNav.open(), b && b.stopPropagation ? (b.stopPropagation(), b.currentTarget.setAttribute("data-expanded", "true"), this.activeSource = b.currentTarget) : h && (h.setAttribute("data-expanded", "true"), this.activeSource = h), theme.Helpers.prepareTransition(this.drawer, function() {
        this.drawer.classList.add(this.config.activeDrawer);
        590 < window.innerWidth && (document.querySelector("#SiteHeader").style.zIndex = 27);
      }.bind(this)), document.documentElement.classList.add(this.config.openClass), this.announcementWrapper && "true" != this.announcementWrapper.dataset.dynamic && (this.announcementWrapper.style.zIndex = "27"), "MenuDrawer" == this.config.id && this.nodes.header.classList.contains("is-light") && (this.isLight = !0, this.nodes.header.classList.remove("is-light")), this.isOpen = !0, slate.a11y.trapFocus({container:this.drawer, namespace:"drawer_focus"}), document.dispatchEvent(new CustomEvent("drawerOpen")), 
      document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id)), this.bindEvents());
    }, close:function(b) {
      !this.isOpen || b && !b.target.closest(this.config.close) && !b.target.closest(this.config.close2) && b.target.closest(".drawer") || (this.mobileNav.close(), document.activeElement.blur(), theme.Helpers.prepareTransition(this.drawer, function() {
        this.drawer.classList.remove(this.config.activeDrawer);
        590 < window.innerWidth && (document.querySelector("#SiteHeader").style.zIndex = 28);
      }.bind(this)), document.documentElement.classList.remove(this.config.openClass), document.documentElement.classList.add(this.config.closingClass), this.announcementWrapper && "true" != this.announcementWrapper.dataset.dynamic && (this.announcementWrapper.style.zIndex = "29"), window.setTimeout(function() {
        document.documentElement.classList.remove(this.config.closingClass);
        this.activeSource && this.activeSource.getAttribute("data-expanded") && (this.activeSource.setAttribute("data-expanded", "false"), this.activeSource.focus());
      }.bind(this), 500), this.isOpen = !1, this.isLight && (this.isLight = !1, this.nodes.header.classList.add("is-light")), slate.a11y.removeTrapFocus({container:this.drawer, namespace:"drawer_focus"}), this.unbindEvents());
    }, bindEvents:function() {
      window.on("click" + this.config.namespace, function(b) {
        this.close(b);
      }.bind(this));
      window.on("keyup" + this.config.namespace, function(b) {
        27 === b.keyCode && this.close();
      }.bind(this));
      slate.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
    }, unbindEvents:function() {
      window.off("click" + this.config.namespace);
      window.off("keyup" + this.config.namespace);
      slate.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
    }});
    return d;
  }();
  theme.CartDrawer = function() {
    function d() {
      this.form = document.querySelector(b.form);
      this.drawer = new theme.Drawers("CartDrawer", "cart");
      this.init();
    }
    var b = {drawer:"#CartDrawer", form:"#CartDrawerForm"};
    d.prototype = Object.assign({}, d.prototype, {init:function() {
      this.cartForm = new theme.Cart(this.form);
      this.cartForm.buildCart();
      document.addEventListener("ajaxProduct:added", function(h) {
        this.cartForm.buildCart();
        this.open();
      }.bind(this));
      document.addEventListener("cart:open", this.open.bind(this));
      document.addEventListener("cart:close", this.close.bind(this));
    }, open:function() {
      this.drawer.open();
    }, close:function() {
      this.drawer.close();
    }});
    return d;
  }();
  theme.cart = {getCart:function() {
    var d = "".concat(theme.routes.cart, "?t=").concat(Date.now());
    return fetch(d, {credentials:"same-origin", method:"GET"}).then(b => b.json());
  }, getCartProductMarkup:function() {
    var d = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
    d = -1 === d.indexOf("?") ? d + "?view=ajax" : d + "&view=ajax";
    return fetch(d, {credentials:"same-origin", method:"GET"}).then(function(b) {
      return b.text();
    });
  }, changeItem:function(d, b) {
    return this._updateCart({url:"".concat(theme.routes.cartChange, "?t=").concat(Date.now()), data:JSON.stringify({id:d, quantity:b}), type:"application/json"});
  }, _updateCart:function(d) {
    return fetch(d.url, {method:"POST", body:d.data, credentials:"same-origin", headers:{"Content-Type":d.type, "X-Requested-With":"XMLHttpRequest"}}).then(b => b.json()).then(function(b) {
      return b;
    });
  }, updateAttribute:function(d, b) {
    return this._updateCart({url:"/cart/update.js", data:JSON.stringify({attributes:{[d]:theme.cart.attributeToString(b)}}), type:"application/json"});
  }, updateNote:function(d) {
    return this._updateCart({url:"/cart/update.js", data:JSON.stringify({note:theme.cart.attributeToString(d)}), type:"application/json"});
  }, attributeToString:function(d) {
    "string" !== typeof d && (d += "", "undefined" === d && (d = ""));
    return d.trim();
  }};
  theme.Cart = function() {
    function d(a) {
      if (a) {
        this.form = a;
        this.wrapper = a.closest("#CartDrawer");
        this.container = a.closest("#CartDrawer");
        this.container || (this.container = a.closest("#CartPageForm"));
        this.location = a.dataset.location;
        this.namespace = ".cart-" + this.location;
        this.products = a.querySelector(b.products);
        this.submitBtn = this.container.querySelector(b.checkoutBtn);
        this.savings = this.container.querySelector(b.savings);
        this.subtotal = this.container.querySelector(b.subTotal);
        this.total = this.container.querySelector(b.total);
        this.totalAmount;
        if (this.cartGiftCheckbox = this.container.querySelector(b.cartGiftCheckbox)) {
          this.cartGiftCheckbox.removeAttribute("checked"), this.cartGiftForm = this.container.querySelector("#AddToCartForm-" + this.cartGiftCheckbox.value);
        }
        this.cartDiscount = this.container.querySelector(b.cartDiscount);
        this.termsCheckbox = this.container.querySelector(b.termsCheckbox);
        this.cartNote = a.querySelector(b.cartNote);
        this.cartInputNote = a.querySelector(b.cartInputNote);
        this.termsCheckbox && (h = !0);
        this.init();
      }
    }
    var b = {products:"[data-cart-products]", qtySelector:".js-qty__wrapper", savings:"[data-savings]", subTotal:"[data-cart-subtotal]", total:"[data-cart-total]", cartCountBubble:"#CartCount", cartNote:"[data-input-notes]", cartGiftCheckbox:"[data-gift-checkbox]", cartInputNote:"[data-input-notes]", cartDiscount:"[data-cart-discount]", termsCheckbox:".cart__terms-checkbox", checkoutBtn:".cart__checkout", cartItem:".cart__item"};
    var h = !1;
    d.prototype = Object.assign({}, d.prototype, {init:function() {
      this.initQtySelectors();
      document.addEventListener("cart:quantity" + this.namespace, this.quantityChanged.bind(this));
      this.form.on("submit" + this.namespace, this.onSubmit.bind(this));
      this.cartInputNote && this.cartNote && this.cartInputNote.addEventListener("change", function(a) {
        a = a.target.value;
        this.cartInputNote.value = a;
        theme.cart.updateNote(a);
      }.bind(this));
      this.cartGiftCheckbox && this.cartGiftCheckbox.addEventListener("change", function(a) {
        this._setGiftWrapping(a);
      }.bind(this));
      this.cartDiscount && this._setDiscount();
      document.addEventListener("cart:build", function() {
        this.buildCart();
      }.bind(this));
    }, onSubmit:function(a) {
      this.submitBtn.classList.add("btn--loading");
      if (h && this.submitBtn.classList.contains("cart__checkout")) {
        if (!this.termsCheckbox.checked) {
          return alert(theme.strings.cartTermsConfirmation), this.submitBtn.classList.remove("btn--loading"), a.preventDefault(), !1;
        }
      } else {
        this.submitBtn.classList.remove("btn--loading");
      }
    }, _parseProductHTML:function(a) {
      a = (new DOMParser()).parseFromString(a, "text/html");
      return {items:a.querySelector(".cart__items"), discounts:a.querySelector(".cart__discounts")};
    }, buildCart:function() {
      theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
    }, cartMarkup:function(a) {
      var c = this._parseProductHTML(a), g = c.items, f = parseInt(g.dataset.count);
      a = g.dataset.cartSubtotal;
      c = c.discounts.dataset.savings;
      if (null != g.querySelector("[data-custom]")) {
        var m = this._getCustomCount(g);
        0 < m && (f -= m);
      }
      this.updateSavings(c);
      0 < f ? this.container.classList.remove("is-empty") : this.container.classList.add("is-empty");
      this._setCartCountBubble(f);
      this.products.innerHTML = "";
      this.products.append(g);
      this.total && (g = parseInt(a) + parseInt(c), this.total.innerHTML = theme.Currency.formatMoney(g, theme.settings.moneyFormat), this.totalAmount = g);
      this.savings && (this.savings.innerHTML = "-" + theme.Currency.formatMoney(c, theme.settings.moneyFormat));
      this.subtotal && (this.subtotal.innerHTML = theme.Currency.formatMoney(a, theme.settings.moneyFormat));
      this.initQtySelectors();
      Shopify && Shopify.StorefrontExpressButtons && Shopify.StorefrontExpressButtons.initialize();
      localStorage.discountCode && this.applyDiscount(JSON.parse(localStorage.discountCode).code);
    }, initQtySelectors:function() {
      var a = !1;
      this.form.querySelectorAll(b.cartItem);
      this.form.querySelectorAll(b.cartItem).forEach((c, g) => {
        !a && this.cartGiftCheckbox && c.dataset.id == this.cartGiftCheckbox.value && (a = !0, this.cartGiftCheckbox.setAttribute("checked", "true"), c.querySelector(".cart__remove-wrapper").classList.add("hide"), c.querySelector(".js-qty__wrapper").classList.add("hide"), c.querySelector(".cart_pre-order-note") && c.querySelector(".cart_pre-order-note").classList.add("hide"));
        c.querySelector(".cart__item--datepicker") && c.querySelector(".js-qty__wrapper").classList.add("hide");
        this.container.querySelectorAll(".image-grid-item--loader.loading").forEach(f => {
          f.classList.remove("loading", "loading--delayed");
          f.classList.add("loaded");
        });
        new theme.QtySelector(c, {namespace:this.namespace, isCart:!0});
      });
    }, quantityChanged:function(a) {
      var c = a.detail[0], g = a.detail[1];
      a = a.detail[2];
      c && g && (a && a.querySelector(b.qtySelector).classList.add("is-loading"), theme.cart.changeItem(c, g).then(function(f) {
        0 < f.item_count ? this.container.classList.remove("is-empty") : this.container.classList.add("is-empty");
        this.buildCart();
        theme.announcementBar.update();
        document.dispatchEvent(new CustomEvent("cart:updated", {detail:{cart:f}}));
      }.bind(this)).catch(function(f) {
      }));
    }, updateSavings:function(a) {
      this.savings && (0 < a ? (a = theme.Currency.formatMoney(a, theme.settings.moneyFormat), this.savings.classList.remove("hide"), this.savings.innerHTML = theme.strings.cartSavings.replace("[savings]", a)) : this.savings.classList.add("hide"));
    }, _setGiftWrapping:function(a) {
      a.target.checked ? (a = theme.Helpers.serialize(this.cartGiftForm), fetch(theme.routes.cartAdd, {method:"POST", body:a, credentials:"same-origin", headers:{"Content-Type":"application/x-www-form-urlencoded", "X-Requested-With":"XMLHttpRequest"}}).then(c => c.json()).then(function(c) {
        this.buildCart();
        theme.announcementBar.update();
        document.dispatchEvent(new CustomEvent("cart:updated", {detail:{cart:c}}));
      }.bind(this))) : this.form.querySelectorAll(b.cartItem).forEach(c => {
        c.dataset.id == this.cartGiftCheckbox.value && c.querySelector(".js-qty__adjust--empty").click();
      });
    }, _setCartCountBubble:function(a) {
      var c = document.querySelector(".cart-link__bubble-num"), g = document.querySelector(b.cartCountBubble);
      c && (c.innerText = a, g.classList.remove("hide"));
      g && (0 < a && 0 == g.classList.contains("cart-link__bubble--visible") ? g.classList.add("cart-link__bubble--visible") : 0 == a && 1 == g.classList.contains("cart-link__bubble--visible") && g.classList.remove("cart-link__bubble--visible"));
    }, _setDiscount:function() {
      this.clearBtn = this.container.querySelector(".clear-discount-btn");
      this.applyBtn = this.container.querySelector(".btn--discount");
      this.discountCodeError = this.container.querySelector(".discount-code-error");
      this.discountCodeWrapper = this.container.querySelector(".applied-discount-code-wrapper");
      this.discountCodeValue = this.container.querySelector(".applied-discount-code-value");
      this.discountCodeInput = this.container.querySelector(".input-group-field.cart__discount");
      this.authorization_token;
      this.discountCodeInput.classList.remove("error");
      this.checkoutContainer = document.createElement("div");
      document.body.appendChild(this.checkoutContainer);
      this.savings = this.container.querySelector(b.savings);
      this.subtotal = this.container.querySelector(b.subTotal);
      this.total = this.container.querySelector(b.total);
      localStorage.discountCode && this.applyDiscount(JSON.parse(localStorage.discountCode).code);
      this.applyBtn.addEventListener("click", function(a) {
        a.preventDefault();
        this.applyDiscount(this.discountCodeInput.value);
      }.bind(this));
      this.applyBtn.addEventListener("keyup", function(a) {
        a.preventDefault();
        13 === a.keyCode && (e.preventDefault(), this.applyDiscount(this.discountCodeInput.value));
      }.bind(this));
      this.clearBtn && this.clearBtn.addEventListener("click", function(a) {
        this.buildCart();
        a.preventDefault();
        this.clearDiscount();
      }.bind(this));
    }, _getCustomCount:function(a) {
      var c = 0;
      a.querySelectorAll("[data-custom]").forEach((g, f) => {
        "true" == g.dataset.custom && (c = c + parseInt(g.dataset.quantity) - 1);
      });
      return c;
    }, clearDiscount:function() {
      this.discountCodeValue.innerHTML = "";
      this.clearLocalStorage();
      fetch("/discount/CLEAR");
    }, clearLocalStorage:function() {
      this.discountCodeWrapper.style.display = "none";
      localStorage.removeItem("discountCode");
    }, applyDiscount:function(a) {
      this.applyBtn.classList.add("btn--loading");
      this.applyBtn.style.pointerEvents = "none";
      fetch("/payments/config", {method:"GET"}).then(function(c) {
        return c.json();
      }).then(function(c) {
        this.authorization_token = btoa(c.paymentInstruments.accessToken);
        fetch("/cart.js", {}).then(function(g) {
          return g.json();
        }).then(function(g) {
          fetch("/wallets/checkouts/", {headers:{accept:"*/*", "cache-control":"no-cache", authorization:"Basic " + this.authorization_token, "content-type":"application/json, text/javascript", pragma:"no-cache", "sec-fetch-dest":"empty", "sec-fetch-mode":"cors", "sec-fetch-site":"same-origin"}, referrerPolicy:"strict-origin-when-cross-origin", method:"POST", mode:"cors", credentials:"include", body:JSON.stringify({checkout:{discount_code:a, line_items:g.items, presentment_currency:Shopify.currency.active}})}).then(function(f) {
            return f.json();
          }).then(function(f) {
            if (f.checkout && 0 < f.checkout.applied_discounts.length) {
              var m = "/discount/" + a + "?v=" + Date.now() + "&redirect=/checkout/";
              fetch(m, {}).then(function(k) {
                return k.text();
              });
              this.discountCodeError.classList.add("hide");
              this.discountCodeWrapper.style.display = "inline";
              this.dataCheckout = f.checkout;
              this.discountCodeValue.innerHTML = f.checkout.applied_discounts[0].title;
              m = {code:a.trim(), totalCart:f.checkout.total_line_items_price};
              localStorage.setItem("discountCode", JSON.stringify(m));
              this.container.querySelectorAll(b.cartItem).forEach((k, l) => {
                if (f.checkout.line_items && 0 < f.checkout.line_items[l].discount_allocations.length) {
                  parseInt(f.checkout.line_items[l].quantity);
                  var p = f.checkout.line_items[l].discount_allocations[0].amount, q = (parseFloat(f.checkout.line_items[l].line_price) - parseFloat(p)).toFixed(2).toString(), r = f.checkout.line_items[l].discount_allocations[0].description;
                  if (!k.querySelector(".cart__price").classList.contains("cart__price--strikethrough")) {
                    var n = document.createElement("small");
                    n.className = "cart__price cart__price--strikethrough";
                    n.innerHTML = theme.Currency.formatMoney(f.checkout.line_items[l].line_price, theme.settings.moneyFormat);
                    l = k.querySelector(".cart__item--price");
                    l.insertBefore(n, l.firstChild);
                    k.querySelector(".cart__discount").classList.remove("hide");
                    k.querySelector(".cart__discount").innerHTML += '<small class="cart__discount-text"><span class="cart__discount-price"></span></small>';
                  }
                  k.querySelector(".cart__price--final").innerHTML = theme.Currency.formatMoney(q, theme.settings.moneyFormat);
                  k.querySelector(".cart__discount-text").innerHTML = r + " (-" + theme.Currency.formatMoney(p, theme.settings.moneyFormat) + ")";
                } else {
                  k.querySelector(".cart__price").classList.contains("cart__price--strikethrough") && (k.querySelector(".cart__discount").classList.add("hide"), k.querySelector(".cart__price--strikethrough").classList.add("hide"), k.querySelector(".cart__price--final").innerHTML = theme.Currency.formatMoney(f.checkout.line_items[l].line_price, theme.settings.moneyFormat));
                }
                this.total && (this.total.innerHTML = theme.Currency.formatMoney(f.checkout.total_line_items_price, theme.settings.moneyFormat));
                this.savings && (this.savings.innerHTML = "-" + theme.Currency.formatMoney(f.checkout.total_line_level_discount, theme.settings.moneyFormat));
                this.subtotal && (this.subtotal.innerHTML = theme.Currency.formatMoney(f.checkout.total_price, theme.settings.moneyFormat));
              });
            } else {
              this.discountCodeValue.innerHTML = "", this.clearLocalStorage(), this.discountCodeError.classList.remove("hide"), this.discountCodeInput.classList.add("error");
            }
          }.bind(this)).finally(function(f) {
            this.applyBtn.classList.remove("btn--loading");
            this.discountCodeInput.value = "";
            this.applyBtn.style.pointerEvents = "all";
          }.bind(this));
        }.bind(this));
      }.bind(this));
    }});
    return d;
  }();
  theme.cartPage = function() {
    function d() {
      a.querySelectorAll(b.qtySelector).forEach(c => {
        new theme.QtySelector(c, {namespace:h.namespace});
      });
      document.addEventListener("cart:quantity" + h.namespace, function(c) {
        document.getElementById("CartPageUpdate").click();
      });
    }
    var b = {checkoutBtn:".cart__checkout", qtySelector:".js-qty__wrapper"}, h = {namespace:".cartpage"}, a = document.getElementById("CartPageForm");
    return {init:function() {
      document.addEventListener("click", function(c) {
        if (c.target && c.target.classList.contains("cart__checkout")) {
          c.target.classList.add("btn--loading");
          var g = c.target.dataset.terms;
          if (g && !document.getElementById(g).checked) {
            return alert(theme.strings.cartTermsConfirmation), c.target.classList.remove("btn--loading"), c.preventDefault(), !1;
          }
        }
      });
      a && d();
    }};
  }();
  (function(d) {
    "loading" != document.readyState ? d() : document.addEventListener("DOMContentLoaded", d);
  })(function() {
    if (document.body.classList.contains("template-cart")) {
      var d = document.getElementById("CartPageForm");
      d && new theme.Cart(d);
    }
  });
})();